export enum LayoutGridType {
    short = 'short', // small viewport for profile
    shortExtended = 'shortExtended', // tablet and desktop view for profile
    default = 'default', // all grid features
}
